import { AbstractControl } from "@angular/forms"
import { isValidIBAN } from "ibantools"

export function IbanValidator(control: AbstractControl) {
  if (!isValidIBAN(control.value)) {
    return { iban: "keine gültige IBAN" }
  }
  return null
}
